import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { ExternalLink, Text } from 'roo-ui/components';
import { LUXE_URL } from 'config/constants';
import { luxuryOffersLinkSelected } from 'lib/gaTracking/cancelBookingPageEvents';
import { CreditVoucherDisclaimer, PointsDisclaimer } from 'components/Disclaimers';

const StyledExternalLink = styled(ExternalLink)`
  color: ${themeGet('colors.brand.primary')} !important;
`;

export interface CreditVoucherRefundMessageProps {
  propertyName: string;
  email: string;
}

const CreditVoucherRefundMessage = ({ propertyName, email }: CreditVoucherRefundMessageProps) => (
  <Text fontSize="18px" data-testid="credit-voucher-refund-message">
    Your booking at {propertyName} has been cancelled. You will receive confirmation and your credit voucher details via email to{' '}
    <b>{email}</b>
    <br />
    <br />
    Thank you for choosing a Qantas Hotels credit voucher
    <CreditVoucherDisclaimer.Link /> as your refund option.
    <br />
    <br />
    When you&#39;re ready to use it, you&#39;ll earn from 3 Qantas Points per A$1 spent
    <PointsDisclaimer.Link /> on over 460,000 hotels worldwide, or on our range of expertly curated{' '}
    <StyledExternalLink data-testid="luxury-offer-link" href={LUXE_URL} onClick={luxuryOffersLinkSelected} underline>
      Luxury Holidays
    </StyledExternalLink>{' '}
    with exclusive savings and premium inclusions.
    <br />
    <br />
    We hope to see you again soon.
  </Text>
);

export default CreditVoucherRefundMessage;
